export default function DeveloperSection() {
  return (
    <section className="relative py-24 px-4 overflow-hidden text-white">
      {/* Background Image */}
      {/* Background Building Visual - Restored per user request with professional overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/kareyapi-hq.png" 
          alt="Building Background" 
          className="w-full h-full object-cover object-center opacity-30 grayscale brightness-[0.3] scale-105"
        />
        <div className="absolute inset-0 bg-slate-900/60 backdrop-blur-[2px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6" style={{ fontFamily: 'Raleway, sans-serif' }}>
              KARE YAPI İNŞAAT
            </h2>
            <div className="space-y-4 text-teal-50 leading-relaxed">
              <p>
                KARE YAPI İNŞAAT, 15 yılı aşkın süredir inşaat sektöründe faaliyet gösteren, 
                güvenilir ve kaliteli projeleriyle tanınan bir firmadır. Müşteri memnuniyetini 
                ön planda tutan anlayışımız ile her projede mükemmeliyeti hedefliyoruz.
              </p>
              <p>
                Deneyimli kadromuz, modern teknolojiler ve kaliteli malzemeler kullanarak, 
                yaşam alanlarınızı hayallerinizin ötesinde tasarlıyor. Her detayda kalite, 
                her projede güven anlayışı ile çalışıyoruz.
              </p>
              <p>
                Projelerimiz, firmamızın deneyimi ve vizyonunun bir yansımasıdır. 
                Müşterilerimize sadece bir ev değil, bir yaşam tarzı sunmayı amaçlıyoruz.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-10">
              <div className="text-left col-span-3">
                <div className="text-5xl font-extrabold mb-2 text-red-500 drop-shadow-lg">15+</div>
                <div className="text-lg text-teal-100 font-semibold tracking-wide uppercase">Yıllık Köklü Tecrübe</div>
              </div>
            </div>
          </div>

          {/* Pristine Architectural Render - Environment Cleaned (v6) */}
          <div className="relative group">
            <div className="relative h-[560px] rounded-3xl overflow-hidden shadow-[0_40px_80px_rgba(0,0,0,0.6)] border border-white/10 bg-slate-800">
              {/* Pure Architectural Render - Environment Cleaned */}
              <img
                src="/new-hq.png"
                alt="KARE YAPI Genel Merkez Binası"
                className="w-full h-full object-cover object-center group-hover:scale-[1.03] transition-transform duration-[2000ms] ease-out"
              />

              {/* Precise Lighting Overlay for Facade Harmony */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-white/5 pointer-events-none"></div>
              
              {/* Orijinal Şeffaf Logo Tabela */}
              <div 
                className="absolute z-10 opacity-[0.98] pointer-events-none drop-shadow-2xl flex items-center justify-center top-[45%] left-1/2 -translate-x-1/2 transition-transform duration-[2000ms] ease-out group-hover:scale-[1.03] group-hover:-translate-x-[50%]"
              >
                <img 
                  src="https://static.readdy.ai/image/462a574349d19c517babfc55bf63e079/c8ac21bc970c8b7e4f4c5b80839b9d5d.png" 
                  alt="KARE YAPI" 
                  className="w-32 md:w-48 lg:w-56 h-auto object-contain filter contrast-125 brightness-110 drop-shadow-[0_2px_4px_rgba(255,255,255,0.2)]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold mb-6">İletişime Geçin</h3>
          <div className="flex flex-wrap justify-center gap-6 text-teal-50">
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-xl"></i>
              <span className="whitespace-nowrap">0 532 500 38 69</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-xl"></i>
              <span className="whitespace-nowrap">info@kareyapıinsaat.com</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-map-pin-line text-xl"></i>
              <span className="whitespace-nowrap">Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}